<div class="border pt-2 table-responsive d-flex flex-column justify-content-between"
  style="border-radius: 1rem; min-height: 910px;">
  <div class="table-aramark table-responsive" style="min-height: 815px;">
    <table class="table am-table mb-0">
      <thead>
        <tr>
          <th scope="col table-title" *ngFor="let title of titles; let i = index">
            <ng-container *ngIf="customHeaderTemplate && i === 0; else defaultHeader">
              <ng-container *ngTemplateOutlet="customHeaderTemplate"></ng-container>
            </ng-container>
            <ng-template #defaultHeader>{{ title }}</ng-template>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-content></ng-content>
      </tbody>
    </table>
  </div>

  <div class="d-flex flex-wrap justify-content-between my-2 mx-4">
    <div class="d-flex justify-content-center align-items-center gap-2">
      <select class="form-select" name="show" id="show" [(ngModel)]="pageLimit" (ngModelChange)="pageChanged($event)">
        <option value="10">Mostrar 10</option>
        <option value="25">Mostrar 25</option>
        <option value="50">Mostrar 50</option>
      </select>
      <span class="text-muted text-nowrap">{{ totalResults || "0" }} resultados</span>
    </div>
    <div class="d-flex align-items-center pt-3">
      <pagination [boundaryLinks]="false" [totalItems]="totalResults" previousText="&lsaquo;" [(ngModel)]="page"
        nextText="&rsaquo;" (pageChanged)="pageChanged($event)" [itemsPerPage]="pageLimit" [maxSize]="6">
      </pagination>
    </div>
  </div>
</div>
